import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'serviceos-ng-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent implements OnInit {

  @Input('tag')
  item;

  constructor() { }

  ngOnInit(): void {
  }

}
